import axios from "axios";
import { API_URL } from "src/scenes/App";

const authorizationConfig = (token) => ({
    headers: {
        Authorization: `Bearer ${token}`
    }
});

const requireResponseField = (response, field) => {
    if (!response.data || response.data[field] === undefined) {
        throw new Error(`Noticeboard API response missing required '${field}' field.`);
    }

    return response.data[field];
};

export const listFeedNotices = async (token, audience, filters = {}) => {
    const endpoint = audience ?
        `${API_URL}/noticeboard/notices/${audience === "employee" ? "employees" : "clients"}` :
        `${API_URL}/noticeboard/notices`;
    const response = await axios.get(endpoint, {
        ...authorizationConfig(token),
        params: {
            filter: "active",
            search: filters.search || undefined,
            checkInCategories: filters.checkInCategories?.length ? filters.checkInCategories : undefined,
            myPostsOnly: filters.myPostsOnly || undefined,
            month: filters.month || undefined,
            year: filters.year || undefined
        }
    });

    return requireResponseField(response, "notices");
};

export const getNotice = async (token, noticeUuid) => {
    const response = await axios.get(
        `${API_URL}/noticeboard/notices/${noticeUuid}`,
        authorizationConfig(token)
    );

    return requireResponseField(response, "notice");
};

export const deleteNotice = async (token, noticeUuid) => {
    await axios.delete(`${API_URL}/noticeboard/${encodeURIComponent(noticeUuid)}`, authorizationConfig(token));
};

export const getNoticeReactions = async (token, noticeUuid) => {
    const response = await axios.get(
        `${API_URL}/noticeboard/${noticeUuid}/reaction`,
        authorizationConfig(token)
    );

    return requireResponseField(response, "reactionsUserDetails");
};

export const setNoticeReaction = async (token, noticeUuid, unicode) => {
    const response = await axios.post(
        `${API_URL}/noticeboard/${noticeUuid}/reaction`,
        { unicode },
        authorizationConfig(token)
    );

    return requireResponseField(response, "notice");
};

export const removeNoticeReaction = async (token, noticeUuid) => {
    const response = await axios.delete(
        `${API_URL}/noticeboard/${noticeUuid}/reaction`,
        authorizationConfig(token)
    );

    return requireResponseField(response, "notice");
};

export const pinNoticePublication = async (token, publicationUuid) => {
    await axios.post(
        `${API_URL}/noticeboard/pinned`,
        { publicationUuid },
        authorizationConfig(token)
    );
};

export const unpinNoticePublication = async (token, publicationUuid) => {
    await axios.delete(
        `${API_URL}/noticeboard/pinned/${publicationUuid}`,
        authorizationConfig(token)
    );
};

export const getNoticeComments = async (token, noticeUuid, page) => {
    const response = await axios.get(
        `${API_URL}/noticeboard/comments/${noticeUuid}`,
        {
            ...authorizationConfig(token),
            params: { page }
        }
    );

    return requireResponseField(response, "comments");
};

export const getCommentReplies = async (token, commentUuid, page) => {
    const response = await axios.get(
        `${API_URL}/noticeboard/comments/${commentUuid}/replies`,
        {
            ...authorizationConfig(token),
            params: { page }
        }
    );

    return requireResponseField(response, "replies");
};

export const createNoticeComment = async (token, target, comment, parentCommentUuid) => {
    const request = { ...target, comment };
    if (parentCommentUuid) {
        request.parentCommentUuid = parentCommentUuid;
    }

    const response = await axios.post(
        `${API_URL}/noticeboard/comments`,
        request,
        authorizationConfig(token)
    );

    return requireResponseField(response, "comment");
};
